import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import type { AttachmentInput, CreateAttachmentMutation } from '#/graphql/types';
import { createAttachment } from '#/graphql/mutations';
import { get } from 'lodash';

const q = gql(createAttachment);

const useAttachmentCreate = () => {
  const [mutation, result] = useMutation<CreateAttachmentMutation>(q);
  const createAttachment = useCallback(
    async (data: AttachmentInput) => {
      const response = await mutation({
        variables: {
          data,
        },
      });

      const result = get(response, 'data.createAttachment', undefined);

      // Check if the operation failed on the backend
      if (result && result.status !== 200) {
        const errorMessage = result.errors?.join('\n') || 'Create failed';
        throw new Error(errorMessage);
      }

      return get(result, 'data', undefined);
    },
    [mutation],
  );

  return { createAttachment, result };
};

export default useAttachmentCreate;
